import { render, staticRenderFns } from "./Detail-Certificate.vue?vue&type=template&id=9e3bd9fc&v-if=pageLoading&"
import script from "./Detail-Certificate.vue?vue&type=script&lang=js&"
export * from "./Detail-Certificate.vue?vue&type=script&lang=js&"
import style0 from "./Detail-Certificate.vue?vue&type=style&index=0&id=9e3bd9fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports